module.exports = __webpack_public_path__ + "img/system27-details.4714efed.png";